import { GetRowIdParams, GridApi } from "ag-grid-community";
import { EntitiesGraphqlDataSource } from "./entitiesGraphqlDataSource";

export const getRowId = (params: GetRowIdParams | Partial<GetRowIdParams>): string => {
  const data: unknown = params.data;
  if (!data || typeof data !== "object" || !("entityId" in data)) return "";
  const entityId = data.entityId;
  if (typeof entityId !== "number") return "";
  return String(entityId);
};

export const updateGridDataSource = (
  gridApi: GridApi | undefined,
  dataSource: EntitiesGraphqlDataSource | null,
): void => {
  if (!gridApi || !dataSource) return;
  gridApi.setGridOption("serverSideDatasource", dataSource);
  gridApi.refreshServerSide({ purge: true });
};
